"use client";

import React, { createContext, useContext, useMemo, useState } from "react";

export type HomeLang = "id" | "en";

type HomeLanguageContextValue = {
  lang: HomeLang;
  setLang: (lang: HomeLang) => void;
};

const HomeLanguageContext = createContext<HomeLanguageContextValue | undefined>(undefined);

export function HomeLanguageProvider({ children }: { children: React.ReactNode }) {
  const [lang, setLang] = useState<HomeLang>("id");

  const value = useMemo(
    () => ({
      lang,
      setLang,
    }),
    [lang]
  );

  return <HomeLanguageContext.Provider value={value}>{children}</HomeLanguageContext.Provider>;
}

export function useHomeLanguage() {
  const context = useContext(HomeLanguageContext);
  if (!context) {
    throw new Error("useHomeLanguage must be used within HomeLanguageProvider");
  }
  return context;
}
